import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=8a6f0e2e&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"
import style0 from "../styles/Manage.css?vue&type=style&index=0&id=8a6f0e2e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6f0e2e",
  null
  
)

export default component.exports